import { ReactNode } from 'react';
import { IconButton, SvgIcon, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider as NotistackProvider, closeSnackbar } from 'notistack';
import {
  Close as CloseIcon,
  InfoOutlined as InfoOutlinedIcon,
  CheckOutlined as CheckOutlinedIcon,
} from '@mui/icons-material';

import { ReactComponent as WarningIcon } from '@/assets/icons-2.0/warning.svg';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent': {
    minWidth: 340,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,

    '#notistack-snackbar': {
      padding: 0,
    },
  },

  '&.notistack-MuiContent-info': {
    backgroundColor: theme.palette.secondary.main,
  },

  '&.notistack-MuiContent-warning': {
    backgroundColor: theme.palette.warning.main,
  },

  '&.notistack-MuiContent-success': {
    backgroundColor: theme.palette.success.main,
  },

  '&.notistack-MuiContent-error': {
    backgroundColor: theme.palette.error.main,
  },
}));

export const SnackbarProvider = (props: { children: ReactNode }) => {
  const { children } = props;

  return (
    <NotistackProvider
      variant="info"
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
      }}
      iconVariant={{
        success: <CheckOutlinedIcon sx={{ mr: 1 }} />,
        error: <InfoOutlinedIcon sx={{ mr: 1 }} />,
        warning: <SvgIcon component={WarningIcon} sx={{ mr: 1 }} />,
        info: <InfoOutlinedIcon sx={{ mr: 1 }} />,
      }}
      action={snackbarId => (
        <IconButton
          onClick={() => closeSnackbar(snackbarId)}
          sx={{
            padding: theme => theme.spacing(0, 1, 0, 0),
          }}
        >
          <CloseIcon sx={{ color: theme => theme.palette.common.white }} />
        </IconButton>
      )}
    >
      {children}
    </NotistackProvider>
  );
};
